import React from 'react';
import { Form } from 'formik';
import FormHeader from '../formHeader/FormHeader';
import FormPage from '../formPage/FormPage';
import Buttons from '../buttonsForm/Buttons';

const FormCard = ({
    page,
    setPage,
    values,
    setValues,
    isSubmitting,
    errors,
    touched,
    handleChange,
}) => {
    return (
        <Form className="createForm">
            <div className="formContent">
                <FormHeader page={page} />
                <FormPage
                    page={page}
                    setPage={setPage}
                    values={values}
                    setValues={setValues}
                    isSubmitting={isSubmitting}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                />
            </div>
            <Buttons
                values={values}
                page={page}
                setPage={setPage}
                isSubmitting={isSubmitting}
                errors={errors}
                touched={touched}
            />
        </Form>
    );
};

export default FormCard;
